// UTM tracking Code

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('[data-service]').forEach(button => {
      const service = button.dataset.service.replace(/\s+/g, '-').toLowerCase();
      const url = new URL(button.href);
      url.searchParams.set('utm_source', 'website');
      url.searchParams.set('utm_medium', 'cta');
      url.searchParams.set('utm_campaign', service);
      button.href = url.toString();
    });
});